import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import { tableRowSx } from "services/constants";
import { Loader } from "components/Loader";
import { themes } from "services/constants";
import sessionHandling from "services/utils/notificationUtils";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import { leaveReportKeyAndHeader } from "pages/TeamZone/TeamZoneHeaders";

export const LeaveReports = ({
  startDate,
  endDate,
  setLeaveReportDetails,
  setMasterLeaveDataForSearch,
  masterLeaveDataForSearch,
  leaveReportDetails,
  fetchDetails,
  setFetchDetails,
  departmentId,
}) => {
  const { domain, token, userDetails, globalSearchValue, topbarCompanyId } =
    useSelector((state) => state.tokenReducer);

  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchUsertaskDetails = async () => {
      try {
        setIsLoading(true);
        let searchStartDate = startDate.split("/").reverse().join("-");
        let searchEndDate = endDate.split("/").reverse().join("-");
        const response = await fetch(
          `${domain}leave_and_absent_reports/?user_id=${userDetails.id}&start_date=${searchStartDate}&end_date=${searchEndDate}&department_id=${departmentId}&company_id=${topbarCompanyId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          setLeaveReportDetails(res?.leave_requests);
          setMasterLeaveDataForSearch(res?.leave_requests);
        } else if (response.status === 409) {
          setLeaveReportDetails([]);
          setMasterLeaveDataForSearch([]);
          sessionHandling();
        } else {
          setLeaveReportDetails([]);
          setMasterLeaveDataForSearch([]);
          throw new Error(res.error);
        }
      } catch (error) {
        setLeaveReportDetails([]);
        setMasterLeaveDataForSearch([]);
        showToast("error", error.message);
      } finally {
        setIsLoading(false);
      }
    };
    if (fetchDetails) {
      fetchUsertaskDetails();
      setFetchDetails(false);
    }
  }, [
    domain,
    token,
    startDate,
    userDetails.id,
    topbarCompanyId,
    endDate,
    fetchDetails,
    setLeaveReportDetails,
    setMasterLeaveDataForSearch,
    setFetchDetails,
    departmentId,
  ]);

  useEffect(() => {
    const filteredResults = masterLeaveDataForSearch?.filter((item) =>
      [
        "username",
        "from_date",
        "to_date",
        "leave_type",
        "approver_name",
        "Status",
      ].some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setLeaveReportDetails(filteredResults);
    setPage(0);
  }, [globalSearchValue, masterLeaveDataForSearch, setLeaveReportDetails]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (topbarCompanyId) {
      setFetchDetails(true);
    }
  }, [setFetchDetails, topbarCompanyId]);

  return isLoading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.TableContainer
          component={Mui.Paper}
          sx={{ mt: 2, width: "100%", paddingRight: 2 }}
        >
          <Mui.Table>
            <Mui.TableHead
              sx={{
                backgroundColor: themes.primary,
              }}
            >
              <Mui.TableRow sx={tableRowSx}>
                {leaveReportKeyAndHeader.map((header) => (
                  <Mui.TableCell
                    sx={{
                      color: themes.headLine,
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    {header.name}
                  </Mui.TableCell>
                ))}
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {leaveReportDetails?.length === 0 ? (
                <InfoMessage dataLength={masterLeaveDataForSearch} />
              ) : (
                leaveReportDetails
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((department) => (
                    <Mui.TableRow sx={tableRowSx}>
                      {leaveReportKeyAndHeader.map((header) => (
                        <Mui.TableCell
                          sx={{ color: themes.headLine, textAlign: "center" }}
                        >
                          {department[header.key]
                            ? department[header.key]
                            : "0"}
                        </Mui.TableCell>
                      ))}
                    </Mui.TableRow>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>

          {leaveReportDetails.length > 25 && (
            <Mui.TablePagination
              className="custom-pagination"
              component="div"
              rowsPerPageOptions={[25, 50, 75, 100]}
              count={leaveReportDetails.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Mui.TableContainer>
      </Mui.Grid>
    </React.Fragment>
  );
};
